<div class="w-full h-full flex flex-col overflow-hidden bg-gray-100">
    <!-- Page Header -->
    <div class="flex-shrink-0 flex flex-col gap-4 bg-gray-100">
        <!-- Tabs -->
        <div class="flex border-b border-gray-200">
            <a routerLink="/settings/store/env" class="px-6 py-3 font-semibold transition-colors border-b-2"
                [class]="activeTab() === 'ENV' ? 'border-indigo-600 text-indigo-700' : 'border-transparent  hover:text-gray-800 hover:border-gray-300'">
                {{'SETNGSTR0001' | translate}}
            </a>
            <a routerLink="/settings/store/staff" class="px-6 py-3 font-semibold transition-colors border-b-2"
                [class]="activeTab() === 'STAFF' ? 'border-indigo-600 text-indigo-700' : 'border-transparent  hover:text-gray-800 hover:border-gray-300'">
                {{'STAFFSTR0001' | translate}}
            </a>
            <a routerLink="/settings/store/members" class="px-6 py-3 font-semibold transition-colors border-b-2"
                (click)="searchMemberShip()"
                [class]="activeTab() === 'MEMBERS' ? 'border-indigo-600 text-indigo-700' : 'border-transparent  hover:text-gray-800 hover:border-gray-300'">
                {{'MEMGRSTR0001' | translate}}
            </a>
            <a routerLink="/settings/store/hours" class="px-6 py-3 font-semibold transition-colors border-b-2"
                (click)="getDataBusinessHours()"
                [class]="activeTab() === 'HOURS' ? 'border-indigo-600 text-indigo-700' : 'border-transparent  hover:text-gray-800 hover:border-gray-300'">
                {{'TIMESSTR0001' | translate}}
            </a>
        </div>
    </div>

    <!-- Main Content Area -->

    <div class="flex-1 p-2 min-h-0 overflow-hidden">
        <input type="file" #fileInput class="hidden" [multiple]="uploadTarget()?.type == 'cover'"
            (change)="onFileSelected($event)" accept="image/png, image/jpeg, image/gif" />
        @if (activeTab() === 'ENV') {
        <div class="flex flex-col xl:flex-row gap-2 w-full h-full">
            <!-- Left Column: Images -->
            <div class="w-full xl:w-[380px] flex-shrink-0 space-y-2" style="height: calc(100vh - 120px)">
                <!-- Representative Image -->
                <div class="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
                    <div
                        class="p-4 border-b border-gray-100 text-gray-800 flex items-center gap-2 fw-600 bg-gray-50/50">
                        {{'SETNGSTR0002' | translate}}
                    </div>
                    <div class="p-2 flex justify-center bg-gray-50/30">
                        <div (click)="triggerFileUpload('rep')"
                            class="relative w-48 h-48 bg-gray-100 rounded-full border-[6px] border-white shadow-lg overflow-hidden group cursor-pointer hover:scale-105 transition-transform">
                            <img [src]="repImageUrl() || defaultImage" (error)="onImageError($event)"
                                class="w-full h-full object-cover" width="400" height="400" />
                            <div
                                class="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center backdrop-blur-[2px]">
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="text-white drop-shadow-lg">
                                    <path
                                        d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z">
                                    </path>
                                    <circle cx="12" cy="13" r="4"></circle>
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Cover Images -->
                <div class="bg-white border border-gray-200 rounded-xl shadow-sm overflow-y-auto"
                    style="height: calc(100% - 242px)">
                    <div class="sticky top-0 z-10 bg-white">
                        <div
                            class="p-2 border-b border-gray-100 text-gray-800 flex justify-between items-center bg-gray-50/50">
                            <div class="flex items-center gap-2 fw-600">
                                {{'SETNGSTR0003' | translate}}
                            </div>
                            <div class="flex gap-4">
                                <button (click)="triggerFileUpload('cover')" [disabled]="coverImageFiles().length == 10"
                                    class="p-1.5  hover:bg-green-50 rounded-lg transition-colors"
                                    [ngClass]="coverImageFiles().length == 10 ? 'text-gray-200' : 'text-green-600'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                                        <path d="M3 15l4-4 4 4 5-5 5 5" />
                                        <circle cx="9" cy="9" r="2" />
                                    </svg>
                                </button>
                                <button (click)="handleCoverSave()"
                                    class="p-1.5 hover:bg-green-50 rounded-lg transition-colors text-green-600">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <path
                                            d="M7 16a4.6 4.4 0 0 1 0-9A5 4.5 0 0 1 12 5a5 4.5 0 0 1 5 4.5a4.6 4.4 0 0 1 0 9Z" />
                                        <path d="M12 12v9" />
                                        <path d="m16 16-4-4-4 4" />
                                    </svg>
                                </button>
                                <button (click)="removeCoverImage(0,true)"
                                    [ngClass]="coverImageFiles().length == 0 ? 'text-gray-200' : 'text-red-500'">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                        <path d="M18 6L6 18" />
                                        <path d="M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="p-4 grid grid-cols-2 gap-4 overflow-y-auto">
                        @for (src of coverImageUrls(); track src; let idx = $index) {
                        <div (click)="triggerFileUpload('cover', idx)"
                            class="relative aspect-video bg-gray-100 rounded-lg border border-gray-200 shadow-sm overflow-hidden group hover:shadow-md transition-all cursor-pointer">
                            <img [src]="src" alt="Cover {{idx+1}}"
                                class="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                width="300" height="200" />
                            <div
                                class="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="text-white drop-shadow">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                                    <polyline points="17 8 12 3 7 8" />
                                    <line x1="12" x2="12" y1="3" y2="15" />
                                </svg>
                            </div>
                            <button (click)="$event.stopPropagation(); removeCoverImage(idx)"
                                class="absolute top-2 right-2 p-1.5 rounded-full bg-white/90 text-red-500 shadow-sm opacity-0 group-hover:opacity-100 transition-opacity hover:bg-red-50">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path d="M18 6 6 18" />
                                    <path d="m6 6 12 12" />
                                </svg>
                            </button>
                        </div>
                        }
                        @if (coverImageFiles().length < 10) { <div (click)="triggerFileUpload('cover')"
                            class="aspect-video border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center cursor-pointer hover:border-indigo-400 hover:bg-indigo-50/50 transition-all text-gray-400 hover:text-indigo-500 gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="M5 12h14" />
                                <path d="M12 5v14" />
                            </svg>
                            <span class=" ">Add</span>
                    </div>
                    }
                </div>
            </div>
        </div>
        <!-- Right Column: Basic Info Form -->
        <div class="flex flex-col gap-2 w-full" style="height: calc(100vh - 120px)">
            <div class="bg-white border border-gray-200 rounded-xl shadow-sm overflow-y-auto setting-store"
                style="height: calc(100% - 70px);">
                <form [formGroup]="form">
                    <div class="sticky top-0 z-10 bg-white">
                        <div
                            class="p-2 border-b border-gray-100 sticky flex justify-between items-center bg-gray-50/50">
                            <h3 class=" text-gray-800 fw-600 flex items-center gap-2">
                                {{'SETNGSTR0004' | translate}}
                            </h3>
                            <button (click)="handleStoreSave()"
                                class="flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-ellipsis text-white  rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px] h-[37px]">
                                {{ (isEditMode ? 'STOREHQ0044' : 'SETNGSTR0005') | translate }}
                            </button>
                        </div>
                    </div>


                    <div class="p-6 md:p-4 space-y-6 overflow-y-auto">
                        <!-- Section 1: General Info -->
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div class="md:col-span-2">
                                <label class="block tracking-wide mb-1.5">
                                    <span class="text-red-500">*</span> {{'SETNGSTR0006' |translate}}
                                </label>
                                <div class="flex gap-4">
                                    <input type="text" formControlName="stR_CD" pInputText class="w-full">
                                    <input type="text" formControlName="stR_NM" pInputText class="w-full">
                                </div>
                            </div>

                            <div>
                                <label class="block   tracking-wide mb-1.5"><span
                                        class="text-red-500">*</span>{{'SETNGSTR0007' |
                                    translate}}</label>
                                <input type="text" formControlName="ceO_NM" pInputText class="w-full" [maxlength]="50">
                                <p *ngIf="form.get('ceO_NM')?.invalid && form.get('ceO_NM')?.touched"
                                    class="text-red-500 text-ellipsis fs-12"
                                    [pTooltip]="'SYSMESER0003' | translate:{ name: 'STOREHQ0011' | translate }">
                                    {{ 'SYSMESER0003' | translate:{ name: 'STOREHQ0011' | translate } }}
                                </p>
                            </div>
                            <div>
                                <label class="block    tracking-wide mb-1.5">{{'SETNGSTR0008'|
                                    translate}}</label>
                                <input type="text" formControlName="biZ_NO" pInputText class="w-full">
                            </div>

                            <div>
                                <label class="block    tracking-wide mb-1.5"><span
                                        class="text-red-500">*</span>{{'SETNGSTR0009' |
                                    translate}}</label>
                                <input type="text" formControlName="biZ_STR_NM" pInputText class="w-full"
                                    [maxlength]="50">
                                <p *ngIf="form.get('biZ_STR_NM')?.invalid && form.get('biZ_STR_NM')?.touched"
                                    class="text-red-500 text-ellipsis fs-12"
                                    [pTooltip]="'SYSMESER0003' | translate:{ name: 'STOREHQ0013' | translate } ">
                                    {{ 'SYSMESER0003' | translate:{ name: 'STOREHQ0013' | translate } }}
                                </p>
                            </div>
                            <div>
                                <label class="block    tracking-wide mb-1.5">{{'SETNGSTR0010' |
                                    translate}}</label>
                                <p-select [options]="bizTypeList" formControlName="biZ_TYPE_CD" optionLabel="comM_D_NM"
                                    optionValue="comM_D_CD" class="w-full" appendTo="body" [filter]="true"
                                    filterBy="comM_D_NM" />
                            </div>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label class="block  tracking-wide mb-1.5"><span
                                        class="text-red-500">*</span>{{'SETNGSTR0011' |
                                    translate}}</label>
                                <input type="text" formControlName="teL_NO" pInputText class="w-full" [maxlength]="14"
                                    inputmode="numeric" (input)="onPhoneInput($event, 'teL_NO')">
                                <p *ngIf="form.get('teL_NO')?.touched && form.get('teL_NO')?.hasError('required')"
                                    class="text-red-500 text-ellipsis fs-12"
                                    [pTooltip]="'SYSMESER0003' | translate:{ name: ('STOREHQ0017' | translate) }">
                                    {{ 'SYSMESER0003' | translate:{ name: ('STOREHQ0017' | translate) } }}
                                </p>

                                <p *ngIf="form.get('teL_NO')?.touched && form.get('teL_NO')?.hasError('invalidTel') && !form.get('teL_NO')?.hasError('required')"
                                    class="text-red-500 text-ellipsis" [pTooltip]="'STOREHQ0041' | translate">
                                    {{ 'STOREHQ0041' | translate }}
                                </p>
                            </div>
                            <div>
                                <label class="block    tracking-wide mb-1.5">{{'SETNGSTR0012' |
                                    translate}}</label>
                                <input type="text" formControlName="hP_NO" pInputText class="w-full" [maxlength]="14"
                                    inputmode="numeric" (input)="onPhoneInput($event, 'hP_NO')">
                                <p *ngIf="form.get('hP_NO')?.touched && form.get('hP_NO')?.hasError('invalidTel')"
                                    class="text-red-500 text-ellipsis fs-12" [pTooltip]="'STOREHQ0041' | translate">
                                    {{ 'STOREHQ0041' | translate }}
                                </p>
                            </div>
                            <div class="md:col-span-2 bg-gray-50 p-4 rounded-lg border border-gray-200">
                                <label class="   tracking-wide mb-2 flex items-center gap-2">
                                    <span class="text-red-500">*</span>{{'SETNGSTR0013' | translate}}
                                </label>
                                <div class="flex gap-2 mb-2">
                                    <input type="text" pInputText class="w-full" formControlName="addr">
                                    <button [disabled]="!isEditMode" (click)="openPostcodeSearch()"
                                        class="px-4 py-2 rounded-lg   text-white transition-all shadow-sm shrink-0 w-[100px] h-[37px]"
                                        [class]="isEditMode ? 'bg-gray-600 hover:bg-gray-700' : 'bg-gray-400 cursor-not-allowed'">
                                        {{'SETNGSTR0014' | translate}}
                                    </button>
                                </div>
                                <div *ngIf="submitted && form.hasError('addrRequired')">
                                    <p class="text-red-500 text-ellipsis fs-12"
                                        [pTooltip]="'SYSMESER0003' | translate:{ name: 'STOREHQ0034' | translate } ">
                                        {{ 'SYSMESER0003' | translate:{ name: 'STOREHQ0034' | translate } }}
                                    </p>
                                </div>
                                <input type="text" class="w-full" pInputText formControlName="addR_DTL"
                                    [maxlength]="100">
                                <p *ngIf="form.get('addR_DTL')?.invalid && form.get('addR_DTL')?.touched"
                                    class="text-red-500 text-ellipsis fs-12"
                                    [pTooltip]="'SYSMESER0003' | translate:{ name: 'STOREHQ0034' | translate }">
                                    {{ 'SYSMESER0003' | translate:{ name: 'STOREHQ0034' | translate } }}
                                </p>

                            </div>
                        </div>

                        <div>
                            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                                <div>
                                    <label class="block   mb-1">{{'SETNGSTR0015' | translate}}</label>
                                    <input type="text" class="w-full" pInputText formControlName="vaN_CD_NM">
                                </div>
                                <div>
                                    <label class="block   mb-1">{{'SETNGSTR0016' | translate}}</label>
                                    <input type="text" class="w-full" pInputText formControlName="tid">
                                </div>
                                <div>
                                    <label class="block   mb-1">{{'SETNGSTR0017' | translate}}</label>
                                    <p-select [options]="comportList" formControlName="comport" optionLabel="comM_D_NM"
                                        optionValue="comM_D_CD" class="w-full" appendTo="body" [filter]="true"
                                        filterBy="comM_D_NM" />
                                </div>
                                <div>
                                    <label class="block   mb-1">{{'SETNGSTR0018' | translate}}</label>
                                    <p-select [options]="baudrateList" formControlName="bauD_RATE"
                                        optionLabel="comM_D_NM" optionValue="comM_D_CD" class="w-full" appendTo="body"
                                        [filter]="true" filterBy="comM_D_NM" />
                                </div>
                            </div>
                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label class="block    tracking-wide mb-1.5">{{'SETNGSTR0034' |
                                    translate}}</label>
                                <p-select [options]="cardDevList" formControlName="carD_DEV_TP" optionLabel="comM_D_NM"
                                    optionValue="comM_D_CD" class="w-full" appendTo="body" [filter]="true"
                                    filterBy="comM_D_NM" />
                            </div>


                        </div>
                        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label class="block    tracking-wide mb-1.5">{{'SETNGSTR0019' |
                                    translate}}</label>
                                <div class="flex items-center h-[37px]">
                                    <p-toggleswitch formControlName="reserveChecked"></p-toggleswitch>
                                </div>
                            </div>

                            <div>
                                <label class="block    tracking-wide mb-1.5">{{'SETNGSTR0020' |
                                    translate}}</label>
                                <p-inputnumber inputId="integeronly" formControlName="reservE_AMT" class="w-full"
                                    [min]="0" [max]="999999999999999" />
                            </div>

                            <div>
                                <label class="block    tracking-wide mb-1.5">{{'SETNGSTR0021' |
                                    translate}}</label>
                                <p-datepicker inputId="calendar-timeonly" formControlName="reservE_START_TIME"
                                    (onShow)="onTimePickerOpen('reservE_START_TIME')" [timeOnly]="true"
                                    [className]="'w-full'" inputStyleClass="w-full" [stepMinute]="15"
                                    (onBlur)="formatTime('reservE_START_TIME')"
                                    (onInput)="onTimeInput($event,'reservE_START_TIME')" />
                            </div>

                            <div>
                                <label class="block    tracking-wide mb-1.5">{{'SETNGSTR0022' |
                                    translate}}</label>
                                <p-datepicker inputId="calendar-timeonly" formControlName="reservE_END_TIME"
                                    [timeOnly]="true" (onShow)="onTimePickerOpen('reservE_END_TIME')" [stepMinute]="15"
                                    inputStyleClass="w-full" [className]="'w-full'"
                                    (onBlur)="formatTime('reservE_END_TIME')"
                                    (onInput)="onTimeInput($event,'reservE_END_TIME')" />
                            </div>

                            <div>
                                <label class="block    tracking-wide mb-1.5">{{'SETNGSTR0023' |
                                    translate}}</label>
                                <p-select [options]="timeFGList" formControlName="reservE_TIME_FG"
                                    optionLabel="comM_D_NM" optionValue="comM_D_CD" class="w-full" appendTo="body"
                                    [filter]="true" filterBy="comM_D_NM" />
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div
                class="flex-1 bg-white border border-gray-200 rounded-xl shadow-sm overflow-y-auto setting-store h-[70px]">
                <div class="flex justify-between gap-2 items-center h-full p-2">
                    <label class="fs-18 fw-700">{{'SETNGSTR0024' | translate}}</label>
                    <div class="flex gap-2">
                        <!-- <button (click)="getActiveKey()"
                            class="h-[40px] w-[200px] text-ellipsis bg-gray-600 hover:bg-gray-700 text-white rounded-lg">{{'AGENTSTR0002'
                            | translate}}</button> -->
                        <button (click)="updateAgent()"
                            class="h-[40px] w-[200px] text-ellipsis bg-gray-600 hover:bg-gray-700 text-white rounded-lg">{{'SETNGSTR0025'
                            | translate}}</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
    }
    @if (activeTab() === "STAFF") {
    <div class="flex flex-col h-full bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden w-full">
        <!-- Toolbar -->
        <div
            class="p-3 lg:p-4 border-b border-gray-200 bg-white flex flex-col sm:flex-row justify-between items-center gap-3 shrink-0">
            <!-- Left: Search Inputs -->
            <div class="flex gap-3 w-full sm:w-auto flex-wrap items-center">
                <!-- Employee Name Search -->
                <div class="flex items-center gap-2">
                    <!-- <label class="  text-gray-700 whitespace-nowrap">{{ "STAFFSTR0002" | translate
                        }}</label> -->
                    <input type="text" [placeholder]="'STAFFSTR0035' | translate" [(ngModel)]="paramStaff.P_USER_NM"
                        (keydown.enter)="getStaffList()" maxlength="50"
                        class="w-40 sm:w-44 px-3 py-2  border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-100 focus:border-indigo-400 outline-none transition-all" />
                </div>

                <!-- Phone Number Search -->
                <div class="flex items-center gap-2">
                    <!-- <label class="  text-gray-700 whitespace-nowrap">{{ "STAFFSTR0003" | translate
                        }}</label> -->
                    <input type="text" [placeholder]="'STAFFSTR0036' | translate" [(ngModel)]="paramStaff.P_TEL_NO"
                        (keydown.enter)="getStaffList()" (input)="onPhoneInputSearch($event)"
                        class="w-40 sm:w-44 px-3 py-2  border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-100 focus:border-indigo-400 outline-none transition-all" />
                </div>
            </div>

            <!-- Right: Action Buttons -->
            <div class="flex gap-2 w-full sm:w-auto flex-wrap items-center justify-end">
                <button (click)="resetStaffSearch()"
                    class="flex-1 w-[70px] 2xl:w-[100px] sm:flex-none px-3 lg:px-4 py-2 bg-gray-600 text-white rounded-lg  lg: font-bold hover:bg-gray-700 flex items-center justify-center gap-1.5 shadow-sm transition-all">
                    {{ "STAFFSTR0004" | translate }}
                </button>

                <button (click)="getStaffList()"
                    class="flex-1 w-[70px] 2xl:w-[100px] sm:flex-none px-3 lg:px-4 py-2 bg-gray-600 text-white rounded-lg  lg: font-bold hover:bg-gray-700 flex items-center justify-center gap-1.5 shadow-sm transition-all">
                    {{ "STAFFSTR0005" | translate }}
                </button>
            </div>
        </div>

        <!-- Main Content -->
        <div class="flex flex-col lg:flex-row flex-1 overflow-hidden bg-gray-50">
            <!-- Left: Table List -->
            <div class="w-full lg:w-[390px] pt-2 pb-2 pl-2 border-gray-200 flex flex-col shrink-0 overflow-y-auto"
                style="max-height: calc(100vh - 180px)">

                <app-material-table class="h-full" [headers]="staffHeaders()" [data]="staffList()" [key]="'useR_ID'"
                    [width]="'w-full'" [rowTemplate]="staffRowTpl" [enablePagination]="true" [pageSize]="P_PAGEROW"
                    (nextPage)="nextPage($event)" [totalCnt]="totalCnt()" [isPaging]="true"
                    [isNextPage]="isNextPage()"></app-material-table>

                <ng-template #staffRowTpl let-staff>
                    <tr class="hover:bg-indigo-50/50 transition-colors h-9 group cursor-pointer "
                        [class.bg-indigo-50]="selectedStaff().useR_ID === staff.useR_ID" (click)="selectStaff(staff)">
                        <td class="border-r border-b 0 px-2">
                            <div class="truncate">
                                {{ staff.useR_NM?.length > 20 ? (staff.useR_NM | slice:0:20) + '...' : staff.useR_NM }}
                            </div>
                        </td>
                        <td class="border-r border-b  px-2">
                            <div>
                                {{ staff.useR_ID }}
                            </div>
                        </td>
                        <td class="px-2 border-b">
                            <div>{{ staff.teL_NO }}</div>
                        </td>
                    </tr>
                </ng-template>
            </div>
            <!-- Right: Detail Form -->
            <div class="flex-1 flex flex-col h-auto lg:h-full bg-gray-50/30">
                <div class="flex-1">
                    <div class="grid grid-cols-1 lg:grid-cols-[3fr_2fr] gap-2 p-2" style="height: calc(100vh - 180px)">
                        <div class="bg-white border border-gray-200 rounded-xl shadow-sm overflow-y-auto flex flex-col">
                            <div class="p-2 lg:p-3 border-b border-gray-200 bg-gray-50/50 shrink-0 sticky bg-white">
                                <div class="flex justify-between w-full">
                                    <h1 class="font-bold text-gray-800 flex items-center">
                                        {{ "STAFFSTR0011" | translate }}
                                    </h1>
                                    <div class="flex gap-2">
                                        <button (click)="onCLickNewStaff()"
                                            class="flex-1 w-[80px] 2xl:w-[100px] sm:flex-none px-4 lg:px-6 py-2 bg-gray-600 text-white rounded-lg  lg: font-bold hover:bg-gray-700 shadow-md flex items-center justify-center gap-1.5 transition-all text-ellipsis">
                                            {{ "USERMAG0003" | translate }}
                                        </button>
                                        <button (click)="saveStaff()"
                                            class="flex-1 w-[80px] 2xl:w-[100px] sm:flex-none px-4 lg:px-6 py-2 bg-gray-600 text-white rounded-lg  lg: font-bold hover:bg-gray-700 shadow-md flex items-center justify-center gap-1.5 transition-all text-ellipsis">
                                            {{ "STAFFSTR0007" | translate }}
                                        </button>
                                        <button (click)="onClickshowConfirmDeleteStaff()"
                                            [class]="selectedStaff()?.hQ_CD === '' || curentId === selectedStaff().useR_ID ? 'pointer-events-none bg-gray-400' : 'bg-gray-600'"
                                            class="flex-1 w-[80px] 2xl:w-[100px] sm:flex-none px-4 lg:px-6 py-2  text-white rounded-lg  lg: font-bold hover:bg-gray-700 shadow-md flex items-center justify-center gap-1.5 transition-all text-ellipsis">
                                            {{ "USERMAG0006" | translate }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <form [formGroup]="formUser" class="overflow-y-auto">
                                <div class="p-6 md:p-4 space-y-6">
                                    <!-- Section 1: General Info -->
                                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                        <div>
                                            <label class="block  tracking-wide mb-1.5"><span
                                                    class="text-red-500">*</span>{{'STAFFSTR0012'
                                                |
                                                translate}}</label>
                                            <input type="text" formControlName="useR_NM" pInputText class="w-full"
                                                [maxlength]="100">
                                            <div
                                                *ngIf="formUser.get('useR_NM')?.invalid && formUser.get('useR_NM')?.touched">
                                                <p class="text-red-500 text-ellipsis"
                                                    [pTooltip]="'SYSMESER0003' | translate:{ name: 'STAFFSTR0012' | translate } ">
                                                    {{ 'SYSMESER0003' | translate:{ name: 'STAFFSTR0012' | translate }
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                        <div>
                                            <label class="block tracking-wide mb-1.5">{{'STAFFSTR0013'
                                                |
                                                translate}}</label>
                                            <input type="text" formControlName="emP_NO" pInputText class="w-full">
                                        </div>
                                        <div class="col-span-2">
                                            <label class="block   uInputIconModuleppercase tracking-wide mb-1.5"><span
                                                    class="text-red-500">*</span>{{'STAFFSTR0014'
                                                |
                                                translate}}</label>
                                            <div class="grid grid-cols-2 gap-4">
                                                <p-iconfield>
                                                    <input type="text" pInputText class="w-full"
                                                        formControlName="useR_ID" [maxlength]="20" [minlength]="3">
                                                    <p-inputicon styleClass="pi pi-check" style="color: #00AAB5;"
                                                        *ngIf="isUserId" />
                                                </p-iconfield>
                                                <div *ngIf="selectedStaff()?.hQ_CD === ''">
                                                    <button (click)="checkUserId()"
                                                        class="w-full 2xl:w-[100px] flex-1 sm:flex-none px-4 lg:px-6 py-2 bg-gray-600 text-white rounded-lg  lg: font-bold hover:bg-gray-700 shadow-md flex items-center justify-center gap-1.5 transition-all">
                                                        {{ "USERMAG0004" | translate }}
                                                    </button>
                                                </div>
                                            </div>
                                            <div
                                                *ngIf="formUser.get('useR_ID')?.touched && formUser.get('useR_ID')?.hasError('required')">
                                                <p class="text-red-500 text-ellipsis"
                                                    [pTooltip]="'SYSMESER0003' | translate:{ name: ('STAFFSTR0014' | translate) }">
                                                    {{ 'SYSMESER0003' | translate:{ name: ('STAFFSTR0014' | translate) }
                                                    }}
                                                </p>
                                            </div>
                                            <div
                                                *ngIf="formUser.get('useR_ID')?.touched && (formUser.get('useR_ID')?.hasError('pattern') || formUser.get('useR_ID')?.hasError('minlength'))">
                                                <p class="text-red-500 text-ellipsis"
                                                    [pTooltip]="'USERMAG0040' | translate">
                                                    {{ 'USERMAG0040' | translate }}
                                                </p>
                                            </div>
                                        </div>
                                        <div>
                                            <label class="block tracking-wide mb-1.5">{{'STAFFSTR0016'
                                                |
                                                translate}}</label>
                                            <!-- <p-password formControlName="password" [toggleMask]="true" [fluid]="true"
                                                [feedback]="false" autocomplete="new-password"
                                                [maxLength]="30"></p-password> -->
                                            <p-iconfield>
                                                <input type="text" formControlName="password" pInputText class="w-full">
                                                <p-inputicon styleClass="pi pi-info-circle cursor-pointer"
                                                    style="color: red;" (click)="op.toggle($event)" />
                                            </p-iconfield>
                                            <p-popover #op>
                                                <div>{{'SYSMESER0024' | translate}}</div>
                                            </p-popover>

                                        </div>
                                        <div>
                                            <label class="block    tracking-wide mb-1.5">{{'STAFFSTR0017'
                                                |
                                                translate}}</label>
                                            <p-select [options]="commonEMP_TP()" formControlName="emP_TP"
                                                optionLabel="comM_D_NM" optionValue="comM_D_CD" class="w-full"
                                                appendTo="body" [filter]="true" filterBy="comM_D_NM" />
                                        </div>
                                        <div>
                                            <label class="block tracking-wide mb-1.5">{{'STAFFSTR0018'
                                                |
                                                translate}}</label>
                                            <p-select [options]="commonEMP_AUTH()" formControlName="emP_AUTH"
                                                optionLabel="comM_D_NM" optionValue="comM_D_CD" class="w-full"
                                                appendTo="body" [filter]="true" filterBy="comM_D_NM" />
                                        </div>
                                        <div class="col-span-2">
                                            <label class="block tracking-wide mb-1.5"><span
                                                    class="text-red-500">*</span>{{'STAFFSTR0019'
                                                |
                                                translate}}</label>
                                            <div class="grid grid-cols-2 gap-4">
                                                <p-iconfield>
                                                    <input type="text" pInputText class="w-full"
                                                        formControlName="teL_NO"
                                                        (input)="onPhoneInput($event, 'teL_NO')" [maxlength]="14">
                                                    <p-inputicon styleClass="pi pi-check" style="color: #00AAB5;"
                                                        *ngIf="isTelNo" />
                                                </p-iconfield>
                                                <button (click)="checkTelNo()"
                                                    class="w-full 2xl:w-[100px] flex-1 sm:flex-none px-4 lg:px-6 py-2 bg-gray-600 text-white rounded-lg  lg: font-bold hover:bg-gray-700 shadow-md flex items-center justify-center gap-1.5 transition-all">
                                                    {{ "USERMAG0004" | translate }}
                                                </button>
                                            </div>
                                            <div
                                                *ngIf="formUser.get('teL_NO')?.touched && formUser.get('teL_NO')?.hasError('required')">
                                                <p class="text-red-500 text-ellipsis"
                                                    [pTooltip]="'SYSMESER0003' | translate:{ name: ('STAFFSTR0019' | translate) }">
                                                    {{ 'SYSMESER0003' | translate:{ name: ('STAFFSTR0019' | translate) }
                                                    }}
                                                </p>
                                            </div>
                                            <div
                                                *ngIf="formUser.get('teL_NO')?.touched && formUser.get('teL_NO')?.hasError('invalidTel') && !formUser.get('teL_NO')?.hasError('required')">
                                                <p class="text-red-500 text-ellipsis"
                                                    [pTooltip]="'STOREHQ0041' | translate">
                                                    {{ 'STOREHQ0041' | translate }}
                                                </p>
                                            </div>
                                        </div>
                                        <div>
                                            <label class="block tracking-wide mb-1.5">{{'STAFFSTR0020'
                                                |
                                                translate}}</label>
                                            <input type="text" formControlName="email" pInputText class="w-full"
                                                [maxlength]="100" inputmode="numeric">
                                            <div
                                                *ngIf="formUser.get('email')?.touched && formUser.get('email')?.hasError('pattern')">
                                                <p class="text-red-500 text-ellipsis"
                                                    [pTooltip]="'STOREHQ0040' | translate">
                                                    {{ 'STOREHQ0040' | translate }}
                                                </p>
                                            </div>
                                        </div>
                                        <div>
                                            <label class="block    tracking-wide mb-1.5">{{'STAFFSTR0021'
                                                |
                                                translate}}</label>
                                            <p-select [options]="commonRETIRE_FG()" formControlName="retirE_FG"
                                                optionLabel="comM_D_NM" optionValue="comM_D_CD" class="w-full"
                                                appendTo="body" [filter]="true" filterBy="comM_D_NM" />
                                        </div>
                                        <div>
                                            <label class="block    tracking-wide mb-1.5">{{'STAFFSTR0022'
                                                |
                                                translate}}</label>
                                            <p-datepicker formControlName="hR_DT" [iconDisplay]="'input'"
                                                [showIcon]="true" (onSelect)="changeDate()" inputId="icondisplay"
                                                styleClass="w-full" [locale]="locale" [dateFormat]="'yy-mm-dd'"
                                                [readonlyInput]="true" [showClear]="true" appendTo="body"
                                                inputStyleClass="w-full" />
                                        </div>
                                        <div>
                                            <label class="block    tracking-wide mb-1.5">{{'STAFFSTR0023'
                                                |
                                                translate}}</label>
                                            <p-datepicker formControlName="retirE_DT" [iconDisplay]="'input'"
                                                [showIcon]="true" [readonlyInput]="true" inputId="icondisplay"
                                                styleClass="w-full" [locale]="locale" [dateFormat]="'yy-mm-dd'"
                                                (onSelect)="changeDate()" [showClear]="true" appendTo="body"
                                                inputStyleClass="w-full" />
                                        </div>
                                        <div class="col-span-2 gap-2">
                                            <label class="block    tracking-wide mb-1.5">{{'STAFFSTR0024'
                                                |
                                                translate}}</label>

                                            <div class="grid grid-cols-2 gap-4">
                                                <input type="text" pInputText class="w-full" formControlName="addr">
                                                <button (click)="openPostcodeSearch(false)"
                                                    class="w-full 2xl:w-[100px] flex-1 sm:flex-none px-4 lg:px-6 py-2 bg-gray-600 text-white rounded-lg  lg: font-bold hover:bg-gray-700 shadow-md flex items-center justify-center gap-1.5 transition-all">
                                                    {{ "STAFFSTR0025" | translate }}
                                                </button>
                                            </div>
                                            <input type="text" class="w-full mt-2" pInputText formControlName="addR_DTL"
                                                [maxlength]="100">
                                            <div *ngIf="submitted && formUser.hasError('addrRequired')">
                                                <p class="text-red-500 text-ellipsis"
                                                    [pTooltip]="'SYSMESER0003' | translate:{ name: 'STAFFSTR0024' | translate } ">
                                                    {{ 'SYSMESER0003' | translate:{ name: 'STAFFSTR0024' | translate }
                                                    }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="col-span-2">
                                            <label
                                                class="block    tracking-wide mb-1.5">{{'STAFFSTR0026'|translate}}</label>
                                            <textarea rows="5" cols="30" class="w-full" pTextarea
                                                formControlName="remark" [maxlength]="500"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <!-- Right Column: Work Hours -->
                        <div class="bg-white border border-gray-200 rounded-xl shadow-sm overflow-y-auto flex flex-col">
                            <div class="p-1 2xl:p-3 border-b border-gray-200 bg-gray-50/50 shrink-0 sticky bg-white">
                                <div class="flex items-center gap-2">
                                    <div class="flex justify-between w-full">
                                        <h1 class="font-bold text-gray-800 flex items-center">
                                            {{ "STAFFSTR0027" | translate }}
                                        </h1>
                                        <div
                                            [class]="selectedStaff()?.hQ_CD !== '' ? 'opacity-1' : 'opacity-0 pointer-events-none'">
                                            <button (click)="saveStaffTime()"
                                                class="flex-1 sm:flex-none px-4 lg:px-6 py-2 bg-gray-600 text-white rounded-lg  lg: font-bold hover:bg-gray-700 shadow-md flex items-center justify-center gap-1.5 transition-all">
                                                {{ "STAFFSTR0007" | translate }}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="p-1 2xl:p-4 overflow-y-auto">
                                @for (day of dayCommons; track day) {
                                @let dayLangCode =
                                day.comM_D_CD === "2"
                                ? "STAFFSTR0028"
                                : day.comM_D_CD === "3"
                                ? "STAFFSTR0029"
                                : day.comM_D_CD === "4"
                                ? "STAFFSTR0030"
                                : day.comM_D_CD === "5"
                                ? "STAFFSTR0031"
                                : day.comM_D_CD === "6"
                                ? "STAFFSTR0032"
                                : day.comM_D_CD === "7"
                                ? "STAFFSTR0033"
                                : "STAFFSTR0034";
                                <div class="bg-gray-50/50 border-b border-gray-200 py-2 mb-2">
                                    <span class=" font-bold text-gray-800">
                                        {{ dayLangCode | translate }}
                                    </span>
                                </div>
                                @let daySchedules = daySchedulesMap().get(day.comM_D_CD) ?? [];
                                <div *ngFor="let schedule of daySchedules; let i = index"
                                    class="grid grid-cols-12 w-full">
                                    <div class="col-span-5">
                                        <p-datepicker inputId="calendar-timeonly" [showClear]="true" [stepMinute]="15"
                                            (onShow)="onTimePickerStaffOpen(schedule)" [(ngModel)]="schedule.starT_TIME"
                                            [timeOnly]="true" [className]="'flex-1 px-2 py-1.5  text-center'"
                                            appendTo="body" inputStyleClass="w-full text-center"
                                            (onBlur)="formatTimeStaffOpen(schedule)"
                                            (onInput)="onTimeInputStaffOpen($event,schedule)" />
                                    </div>
                                    <div class="col-span-1 text-center">
                                        <div class="flex items-center h-full">
                                            <span class="w-full">~</span>
                                        </div>
                                    </div>
                                    <div class="col-span-5">
                                        <p-datepicker inputId="calendar-timeonly" [showClear]="true" [stepMinute]="15"
                                            (onShow)="onTimePickerStaffOpen(schedule, false)"
                                            [(ngModel)]="schedule.enD_TIME" [timeOnly]="true"
                                            [className]="'flex-1 px-2 py-1.5  text-center'" appendTo="body"
                                            inputStyleClass="w-full text-center"
                                            (onBlur)="formatTimeStaffOpen(schedule, false)"
                                            (onInput)="onTimeInputStaffOpen($event,schedule, false)" />
                                    </div>
                                    <div class="col-span-1">
                                        <div class="flex items-center justify-end h-full"
                                            *ngIf="daySchedules.length === 1">
                                            <button (click)="addWorkHourSequence(schedule.day)"
                                                class="w-7 h-7 flex items-center justify-center rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200 transition-colors shrink-0">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                                    <path d="M5 12h14" />
                                                    <path d="M12 5v14" />
                                                </svg>
                                            </button>
                                        </div>

                                        <div class="flex items-center justify-end h-full"
                                            *ngIf="daySchedules.length > 1">
                                            <button (click)="removeWorkHourSequence(schedule.day, schedule.daY_SEQ)"
                                                class="w-7 h-7 flex items-center justify-center rounded-full bg-red-100 text-red-600 hover:bg-blue-200 transition-colors shrink-0">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                                    <path d="M5 12h14" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    }
    @if (activeTab() === 'MEMBERS') {
    <div class="space-y-2">
        <div class="bg-white p-2 rounded-lg shadow-sm border border-gray-200">
            <div class="flex justify-between">
                <div class="grid grid-cols-2 gap-2">
                    <div class="flex gap-4">
                        <div class="flex items-center">
                            <label class="w-36 text-ellipsis" [pTooltip]="'MEMGRSTR0002' | translate">{{'MEMGRSTR0002' |
                                translate}}</label>
                        </div>
                        <div class="flex items-center">
                            <div class="flex gap-4">
                                <div *ngFor="let fg of MemberFGList" class="field-checkbox"
                                    (click)="toggleRadiomembeR_FG(fg.comM_D_CD)">
                                    <p-radiobutton [inputId]="MemberFGList" name="memberFG" [value]="fg.comM_D_CD"
                                        [ngModel]="storeInfo.membeR_FG" />
                                    <label [for]="fg.comM_D_CD" class="ml-2">{{ fg.comM_D_NM }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex gap-4">
                        <div class="flex items-center">
                            <label class="w-36 text-ellipsis" [pTooltip]="'MEMGRSTR0008' | translate">{{'MEMGRSTR0008' |
                                translate}}</label>
                        </div>
                        <div>
                            <p-inputnumber [(ngModel)]="storeInfo.miN_POINT" inputId="expiry" class="w-64" min="0"
                                [suffix]="' ' + ('MEMGRSTR0025' | translate)" max="999999999999999" />
                        </div>
                    </div>

                    <div class="flex gap-4">
                        <div class="flex items-center">
                            <label class="w-36 text-ellipsis" [pTooltip]="'MEMGRSTR0003' | translate">{{'MEMGRSTR0003' |
                                translate}}</label>
                        </div>
                        <div class="flex items-center">
                            <div class="flex gap-4">
                                <div *ngFor="let fg of SaveChargeFGList" class="field-checkbox"
                                    (click)="toggleRadiosavE_CHARGE_FG(fg.comM_D_CD)">
                                    <p-radiobutton [inputId]="SaveChargeFGList" name="SavehChargeFG"
                                        [value]="fg.comM_D_CD" [ngModel]="storeInfo.savE_CHARGE_FG" />
                                    <label [for]="fg.comM_D_CD" class="ml-2">{{ fg.comM_D_NM }}</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex gap-4">
                        <div class="flex items-center">
                            <label class="w-36 text-ellipsis" [pTooltip]="'MEMGRSTR0009' | translate">{{'MEMGRSTR0009' |
                                translate}}</label>
                        </div>
                        <div class="w-64">
                            <p-select [options]="LvlPeriodList" [(ngModel)]="storeInfo.poinsT_PERIOD"
                                (ngModelChange)="onLvlPeriodChange( product, $event)" appendTo="body"
                                optionLabel="comM_D_NM" optionValue="comM_D_CD" class="w-64" />
                            <!-- <p-inputnumber [(ngModel)]="storeInfo.poinsT_PERIOD" class="w-64" inputId="mile"
                                [suffix]="' ' + ('MEMGRSTR0026' | translate)" /> -->
                        </div>
                    </div>
                </div>
                <div class="flex gap-2">
                    <!-- <button (click)="searchMemberShip()"
                        class="h-[40px] flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-white   rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px]">{{'MEMGRSTR0010'
                        | translate}}</button> -->
                    <button (click)="updateStore()"
                        class="h-[40px] flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-white   rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px]">{{'MEMGRSTR0011'
                        | translate}}</button>
                </div>
            </div>
        </div>

        <!-- Tables -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <!-- Membership Levels Card -->
            <div class="bg-white rounded-lg shadow-sm border border-gray-200 flex flex-col">
                <div class="p-4 flex justify-between items-center border-b border-gray-200">
                    <h3 class="fw-700">{{'MEMGRSTR0012' | translate}}</h3>
                    <div class="flex space-x-2">
                        <button (click)="addMemberLevel()"
                            class="h-[40px] flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-white   rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px]">{{'MEMGRSTR0014'
                            | translate}}</button>
                        <button (click)="updateOrDeleteMemberLvls(actionAdd)"
                            [class]="selectedLevelEdit ? 'bg-gray-600' : 'bg-gray-400 pointer-events-none'"
                            class="h-[40px] flex-1 lg:flex-none px-5 py-2.5  text-white   rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px]">{{'MEMGRSTR0011'
                            | translate}}</button>
                        <button (click)="onClickshowConfirmDelete('LEVEL')"
                            [class]="selectedLevels.length > 0 ? 'bg-gray-600' : 'bg-gray-400 pointer-events-none'"
                            class="h-[40px] flex-1 lg:flex-none px-5 py-2.5 text-white   rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px]">{{'MEMGRSTR0013'
                            | translate}}</button>
                    </div>
                </div>
                <div class="overflow-auto">
                    <p-table [value]="levels" [(selection)]="selectedLevels" dataKey="no" showGridlines>
                        <ng-template #header>
                            <tr>
                                <th style="width: 4rem">
                                    <p-tableHeaderCheckbox />
                                </th>
                                <th [width]="'20%'">{{'MEMGRSTR0015' | translate}}</th>
                                <th [width]="'20%'">{{'MEMGRSTR0016' | translate}}</th>
                                <th [width]="'20%'">{{'MEMGRSTR0017' | translate}}</th>
                                <th [width]="'20%'">{{'MEMGRSTR0018' | translate}}</th>
                                <th [width]="'20%'">{{'MEMGRSTR0019' | translate}}</th>
                            </tr>
                        </ng-template>
                        <ng-template #body let-product>
                            <tr (click)="selectEdit(product, true)"
                                [ngClass]="{'selected': product.no=== selectedLevelEdit?.no}">
                                <td (click)="$event.stopPropagation()">
                                    <p-tableCheckbox [value]="product" />
                                </td>
                                <td>
                                    <span
                                        *ngIf="product.no !== selectedLevelEdit?.no || !product.newFG">{{product.membeR_TP_NM}}</span>
                                    <div *ngIf="product.no=== selectedLevelEdit?.no && product.newFG">
                                        <p-select [options]="memberTPList" [(ngModel)]="product.membeR_TP"
                                            (ngModelChange)="onMemberTypeChange( product, $event)" appendTo="body"
                                            optionLabel="comM_D_NM" optionValue="comM_D_CD" class="w-full" />
                                    </div>
                                </td>
                                <td class="text-end-custom">
                                    <span *ngIf="product.no !== selectedLevelEdit?.no">{{product.membeR_TP_PRICE
                                        | number}}</span>
                                    <div *ngIf="product.no=== selectedLevelEdit?.no">
                                        <p-inputnumber [(ngModel)]="product.membeR_TP_PRICE" class="w-full" min="0"
                                            max="999999999999999" inputStyleClass="w-full" />
                                    </div>
                                </td>
                                <td class="text-end-custom">
                                    <!-- <span *ngIf="product.no!== selectedLevelEdit?.no">{{product.membeR_TP_CNT
                                        | number}}</span> -->
                                    <div *ngIf="product.no !== selectedLevelEdit?.no" class="input-none">
                                        <p-inputnumber [(ngModel)]="product.membeR_TP_CNT" class="w-full" min="0"
                                            max="999999" inputStyleClass="w-full" />
                                    </div>
                                    <div *ngIf="product.no=== selectedLevelEdit?.no">
                                        <p-inputnumber [(ngModel)]="product.membeR_TP_CNT" class="w-full" min="0"
                                            max="999999" inputStyleClass="w-full" />
                                    </div>
                                </td>
                                <td class="text-end-custom">
                                    <span *ngIf="product.no!== selectedLevelEdit?.no">{{product.membeR_SAVE_RATE
                                        | number}}%</span>
                                    <div *ngIf="product.no=== selectedLevelEdit?.no">
                                        <p-inputnumber [(ngModel)]="product.membeR_SAVE_RATE" inputId="mile" suffix="%"
                                            min="0" max="100" class="w-full" inputStyleClass="w-full" />
                                    </div>
                                </td>
                                <td class="text-end-custom">
                                    <span *ngIf="product.no!== selectedLevelEdit?.no">{{product.membeR_DICOUNT_RATE
                                        | number}}%</span>
                                    <div *ngIf="product.no=== selectedLevelEdit?.no">
                                        <p-inputnumber [(ngModel)]="product.membeR_DICOUNT_RATE" inputId="mile" min="0"
                                            max="100" class="w-full" inputStyleClass="w-full" suffix="%" />
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>

            <!-- Flat Rate Management Card -->
            <div class="bg-white rounded-lg shadow-sm border border-gray-200 flex flex-col">
                <div class="p-4 flex justify-between items-center border-b border-gray-200">
                    <h3 class="fw-700">{{'MEMGRSTR0020' | translate}}</h3>
                    <div class="flex space-x-2">
                        <button (click)="addFlatRate()"
                            class="h-[40px] flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-white   rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px]">
                            {{'MEMGRSTR0014' | translate}}
                        </button>
                        <button (click)="updateOrDeleteMemberPrices(actionAdd)"
                            [class]="selectedMemberPriceEdit ? 'bg-gray-600' : 'bg-gray-400 pointer-events-none'"
                            class="h-[40px] flex-1 lg:flex-none px-5 py-2.5 text-white   rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px]">{{'MEMGRSTR0011'
                            | translate}}</button>
                        <button (click)="onClickshowConfirmDelete('PRICE')"
                            [class]="selectedMemberPrices.length > 0 ? 'bg-gray-600' : 'bg-gray-400 pointer-events-none'"
                            class="h-[40px] flex-1 lg:flex-none px-5 py-2.5 text-white   rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px]">
                            {{'MEMGRSTR0013' | translate}}
                        </button>
                    </div>
                </div>
                <div class="overflow-auto">
                    <p-table [value]="memberPrices" [(selection)]="selectedMemberPrices" dataKey="no" showGridlines>
                        <ng-template #header>
                            <tr>
                                <th style="width: 4rem">
                                    <p-tableHeaderCheckbox />
                                </th>
                                <th [width]="'25%'">{{'MEMGRSTR0021' | translate}}</th>
                                <th [width]="'25%'">{{'MEMGRSTR0022' | translate}}</th>
                                <th [width]="'25%'">{{'MEMGRSTR0023' | translate}}</th>
                                <th [width]="'25%'">{{'MEMGRSTR0024' | translate}}</th>
                            </tr>
                        </ng-template>
                        <ng-template #body let-product>
                            <tr (click)="selectEdit(product)"
                                [ngClass]="{'selected': product.no === selectedMemberPriceEdit?.no}">
                                <td (click)="$event.stopPropagation()">
                                    <p-tableCheckbox [value]="product" />
                                </td>
                                <td>
                                    <span
                                        *ngIf="product.no !== selectedMemberPriceEdit?.no || !product.newFG">{{product.membeR_LVL_NM}}</span>
                                    <div *ngIf="product.no === selectedMemberPriceEdit?.no && product.newFG">
                                        <p-select [options]="memberLvlList" [(ngModel)]="product.membeR_LVL"
                                            (ngModelChange)="onMemberLvlChange( product, $event)" appendTo="body"
                                            optionLabel="comM_D_NM" optionValue="comM_D_CD" class="w-full" />
                                    </div>
                                </td>
                                <td class="text-end-custom">
                                    <div *ngIf="product.no !== selectedMemberPriceEdit?.no" class="input-none">
                                        <p-inputnumber [(ngModel)]="product.lvL_PRICE" inputId="mile" class="w-full"
                                            min="0" max="999999999999999" inputStyleClass="w-full"
                                            [suffix]="' ' + ('USERMAG0048' | translate)" />
                                    </div>
                                    <!-- <span *ngIf="product.no !== selectedMemberPriceEdit?.no">{{product.lvL_PRICE
                                        | number}} {{'USERMAG0048' | translate}}</span> -->
                                    <div *ngIf="product.no === selectedMemberPriceEdit?.no">
                                        <p-inputnumber [(ngModel)]="product.lvL_PRICE" inputId="mile" class="w-full"
                                            min="0" max="999999999999999" inputStyleClass="w-full"
                                            [suffix]="' ' + ('USERMAG0048' | translate)" />
                                    </div>
                                </td>
                                <td class="text-end-custom">
                                    <span *ngIf="product.no !== selectedMemberPriceEdit?.no">{{product.lvL_SAVE_POINT
                                        | number}}</span>
                                    <div *ngIf="product.no === selectedMemberPriceEdit?.no">
                                        <p-inputnumber [(ngModel)]="product.lvL_SAVE_POINT" class="w-full" min="0"
                                            max="999999999999999" inputStyleClass="w-full" />
                                    </div>

                                </td>
                                <td>
                                    <span
                                        *ngIf="product.no !== selectedMemberPriceEdit?.no">{{product.lvL_USE_PERIOD_NM}}</span>
                                    <div *ngIf="product.no === selectedMemberPriceEdit?.no">
                                        <p-select [options]="LvlPeriodList" [(ngModel)]="product.lvL_USE_PERIOD"
                                            (ngModelChange)="onLvlPeriodChange( product, $event)" appendTo="body"
                                            optionLabel="comM_D_NM" optionValue="comM_D_CD" class="w-full" />
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </div>
    </div>
    }
    @if (activeTab() === 'HOURS'){
    <div class="flex flex-col h-full w-full">
        <div
            class="flex justify-between items-center bg-white p-1 rounded-lg border border-gray-200 flex-shrink-0 mb-4 shadow-sm">
            <div class="flex items-center space-x-1">
                <button (click)="hoursTab.set('SETTINGS')" class="px-5 py-2  font-semibold rounded-md"
                    [class]="hoursTab() === 'SETTINGS' ? 'bg-indigo-100 text-indigo-700' : ' hover:bg-gray-100'">
                    {{'TIMESSTR0001' | translate}}</button>
                <button (click)="hoursTab.set('SCHEDULE')" class="px-5 py-2  font-semibold rounded-md"
                    [class]="hoursTab() === 'SCHEDULE' ? 'bg-indigo-100 text-indigo-700' : ' hover:bg-gray-100'">
                    {{'TIMESSTR0002' | translate}}</button>
            </div>
            <button (click)="handleSaveBusinessHours()" [class]="hoursTab() === 'SETTINGS' ? 'opacity-1' : 'opacity-0'"
                class="h-[40px] flex-1 lg:flex-none px-5 py-2.5 bg-gray-600 text-white   rounded-md hover:bg-gray-700 transition-colors flex items-center justify-center gap-2 shadow-sm w-[100px]">{{'TIMESSTR0012'
                | translate}}</button>

        </div>
        <div class="grid grid-cols-12 overflow-auto gap-2 min-h-0 h-full">
            @if (hoursTab() === 'SETTINGS') {
            <div class="col-span-12">
                <div class="flex-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 auto-rows-min">
                    @for (schedule of businessHours; track schedule.day) {
                    <div class="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
                        <div class="bg-[#374151] text-white p-4 flex justify-between items-center">
                            <div class="flex items-center gap-2">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="text-gray-300">
                                    <circle cx="12" cy="12" r="10" />
                                    <path d="M12 6v6l4 2" />
                                </svg>
                                <span *ngIf="schedule.day=== '2'">{{'TIMESSTR0003'|translate}}</span>
                                <span *ngIf="schedule.day=== '3'">{{'TIMESSTR0004'|translate}}</span>
                                <span *ngIf="schedule.day=== '4'">{{'TIMESSTR0005'|translate}}</span>
                                <span *ngIf="schedule.day=== '5'">{{'TIMESSTR0006'|translate}}</span>
                                <span *ngIf="schedule.day=== '6'">{{'TIMESSTR0007'|translate}}</span>
                                <span *ngIf="schedule.day=== '7'">{{'TIMESSTR0008'|translate}}</span>
                                <span *ngIf="schedule.day=== '1'">{{'TIMESSTR0009'|translate}}</span>
                            </div>

                            <button type="button" (click)="schedule.isUse = !schedule.isUse"
                                [class]="schedule.isUse ? 'bg-blue-600' : 'bg-gray-500'"
                                class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none">
                                <span aria-hidden="true" [class]="schedule.isUse ? 'translate-x-5' : 'translate-x-0'"
                                    class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"></span>
                            </button>

                        </div>
                        <div class="p-2 space-y-1 transition-opacity"
                            [class]="!schedule.isUse ? 'opacity-50 pointer-events-none' : ''">
                            <div class="grid grid-cols-12 gap-2">
                                <div class="col-span-3 2xl:col-span-2">
                                    <div class="flex items-center h-full">
                                        <span class="w-full text-ellipsis" [pTooltip]="'TIMESSTR0010' |
                                        translate">{{'TIMESSTR0010' |
                                            translate}}</span>
                                    </div>
                                </div>
                                <div class="col-span-3 2xl:col-span-4">
                                    <p-datepicker inputId="calendar-timeonly" [(ngModel)]="schedule.starT_TIME"
                                        (onShow)="onTimePickerStaffOpen(schedule)" [timeOnly]="true" [stepMinute]="15"
                                        [className]="'flex-1 px-2 py-1.5  text-center'" appendTo="body"
                                        inputStyleClass="w-full text-center" (onBlur)="formatTimeStaffOpen(schedule)"
                                        (onInput)="onTimeInputStaffOpen($event,schedule)" />
                                </div>
                                <div class="col-span-1 text-center">
                                    <div class="flex items-center h-full">
                                        <span class="w-full">~</span>
                                    </div>
                                </div>
                                <div class="col-span-3 2xl:col-span-4">
                                    <p-datepicker inputId="calendar-timeonly" [(ngModel)]="schedule.enD_TIME"
                                        (onShow)="onTimePickerStaffOpen(schedule, false)" [timeOnly]="true"
                                        [stepMinute]="15" [className]="'flex-1 px-2 py-1.5  text-center'"
                                        appendTo="body" inputStyleClass="w-full text-center"
                                        (onBlur)="formatTimeStaffOpen(schedule, false)"
                                        (onInput)="onTimeInputStaffOpen($event,schedule, false)" />
                                </div>
                                <div class="col-span-2 2xl:col-span-1">
                                    <div class="flex items-center justify-end h-full">
                                        <button (click)="addBreakTime(schedule.day)"
                                            class="w-7 h-7 flex items-center justify-center rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200 transition-colors shrink-0"
                                            [disabled]="schedule.breakTimes.length >= 2">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                                                stroke-linecap="round" stroke-linejoin="round">
                                                <path d="M5 12h14" />
                                                <path d="M12 5v14" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            @for(bt of schedule.breakTimes; track bt.timE_SEQ){
                            <div class="flex items-center gap-2">
                                <div class="grid grid-cols-12 gap-2">
                                    <div class="col-span-3 2xl:col-span-2">
                                        <div class="flex items-center h-full">
                                            <span class="w-full text-ellipsis" [pTooltip]="'TIMESSTR0011' |
                                            translate">{{'TIMESSTR0011' |
                                                translate}}</span>
                                        </div>
                                    </div>
                                    <div class="col-span-3 2xl:col-span-4">
                                        <p-datepicker inputId="calendar-timeonly" [(ngModel)]="bt.starT_TIME"
                                            (onShow)="onTimePickerStaffOpen(bt)" [timeOnly]="true" [stepMinute]="15"
                                            [className]="'flex-1 px-2 py-1.5  text-center'" appendTo="body"
                                            inputStyleClass="w-full text-center" (onBlur)="formatTimeStaffOpen(bt)"
                                            (onInput)="onTimeInputStaffOpen($event,bt)" />
                                    </div>
                                    <div class="col-span-1 text-center">
                                        <div class="flex items-center h-full">
                                            <span class="w-full">~</span>
                                        </div>
                                    </div>
                                    <div class="col-span-3 2xl:col-span-4">
                                        <p-datepicker inputId="calendar-timeonly" [(ngModel)]="bt.enD_TIME"
                                            (onShow)="onTimePickerStaffOpen(bt, false)" [timeOnly]="true"
                                            [stepMinute]="15" [className]="'flex-1 px-2 py-1.5 text-center'"
                                            appendTo="body" inputStyleClass="w-full text-center"
                                            (onBlur)="formatTimeStaffOpen(bt, false)"
                                            (onInput)="onTimeInputStaffOpen($event,bt, false)" />
                                    </div>
                                    <div class="col-span-2 2xl:col-span-1">
                                        <div class="flex items-center justify-end h-full">
                                            <button (click)="removeBreakTime(schedule.day, bt.timE_SEQ)"
                                                class="w-7 h-7 flex items-center justify-center rounded-full bg-red-100 text-red-600 hover:bg-red-200 transition-colors shrink-0">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                                    stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                                    <path d="M5 12h14" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                    </div>
                    }
                </div>
            </div>
            } @else {
            <div class="col-span-9" style="height: calc(100vh - 185px);">
                <div
                    class="flex-1 bg-white border border-gray-200 rounded-xl shadow-sm flex flex-col overflow-hidden h-full">
                    <div class="p-2 border-b border-gray-200 flex justify-between items-center bg-white h-[50px]">
                        <button (click)="navigateMonth('prev')"
                            class="p-2 hover:bg-gray-100 rounded-lg border border-gray-200 shadow-sm transition-all text-gray-600">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="m15 18-6-6 6-6" />
                            </svg>
                        </button>
                        <h3 class="fs-26 font-extrabold text-gray-800 flex items-center gap-3 tracking-tight">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="text-indigo-600">
                                <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
                                <line x1="16" x2="16" y1="2" y2="6" />
                                <line x1="8" x2="8" y1="2" y2="6" />
                                <line x1="3" x2="21" y1="10" y2="10" />
                            </svg>
                            {{currentDate() | date:'yyyy-MM'}}
                        </h3>
                        <button (click)="navigateMonth('next')"
                            class="p-2 hover:bg-gray-100 rounded-lg border border-gray-200 shadow-sm transition-all text-gray-600">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="m9 18 6-6-6-6" />
                            </svg>
                        </button>
                    </div>
                    <div
                        class="grid grid-cols-7 bg-white text-center h-[50px] py-4  tracking-wider  border-b border-gray-200">
                        <div class="text-red-500">{{'TIMESSTR0036' | translate}}</div>
                        <div>{{'TIMESSTR0016' | translate}}</div>
                        <div>{{'TIMESSTR0017' | translate}}</div>
                        <div>{{'TIMESSTR0018' | translate}}</div>
                        <div>{{'TIMESSTR0019' | translate}}</div>
                        <div>{{'TIMESSTR0020' | translate}}</div>
                        <div class="text-blue-500">{{'TIMESSTR0021' | translate}}</div>
                    </div>
                    <div
                        class="grid grid-cols-7 flex-1 auto-rows-fr bg-gray-200 gap-px border-b border-gray-200 overflow-hidden">
                        @for(week of calendarDays(); track trackByWeek($index, week)) {
                        @for(day of week; track trackByDay($index, day)) {
                        @let isEffectivelyClosed = day.isHolidayYN !== "N" && day.isClosed || (day.isCurrentMonth &&
                        day.isWeeklyClosed && day.isHolidayYN !== "N");
                        <div class="p-2 flex flex-col justify-between relative transition-all duration-200"
                            [class]="isEffectivelyClosed ? 'bg-red-50' : (day.isCurrentMonth ? 'bg-white' : 'bg-gray-50')">
                            <span class="text-right flex justify-end">
                                <span class="flex items-center justify-center w-6 h-6"
                                    [class.rounded-full]="isToday(day.date)" [class.bg-indigo-600]="isToday(day.date)"
                                    [class.text-white]="isToday(day.date)" [class]="
                                        day.date.getDay() + 1 === 1 ? 'text-red-500' :
                                        day.date.getDay() + 1 === 7 ? 'text-blue-500' :
                                        (day.isCurrentMonth ? 'text-gray-700' : 'text-gray-400')
                                    ">
                                    {{ day.day }}
                                </span>
                            </span>
                            @if(day.isCurrentMonth) {
                            <div class="flex flex-col items-center gap-1">
                                @if(isEffectivelyClosed) {
                                <div class="  text-red-500  tracking-wide">Closed</div>
                                }
                                <button type="button" (click)="toggleDate(day.date)" [disabled]="isPastDate(day.date)"
                                    [class.opacity-50]="isPastDate(day.date)"
                                    [class.cursor-not-allowed]="isPastDate(day.date)"
                                    class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none"
                                    [class]="isEffectivelyClosed ? 'bg-gray-200' : 'bg-indigo-600'">
                                    <span aria-hidden="true"
                                        class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                                        [class]="isEffectivelyClosed ? 'translate-x-0' : 'translate-x-5'"></span>
                                </button>
                            </div>
                            }
                        </div>
                        }
                        }
                    </div>
                </div>
            </div>
            <div class="col-span-3" style="height: calc(100vh - 185px);">

                <div
                    class="flex-1 bg-white border border-gray-200 rounded-xl shadow-sm flex flex-col overflow-hidden h-full">
                    <div
                        class="bg-[#374151] text-white text-center flex p-2 h-[50px] flex-col items-center justify-center relative overflow-hidden rounded-t-xl">
                        <h3 class=" text-lg relative z-10">{{'TIMESSTR0022' | translate}}</h3>
                    </div>
                    <div class="p-2 border-b border-gray-200 flex justify-between items-center bg-white h-[50px]">
                        <button (click)="navigateYear('prev')"
                            class="p-2 hover:bg-gray-100 rounded-lg border border-gray-200 shadow-sm transition-all text-gray-600">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="m15 18-6-6 6-6" />
                            </svg>
                        </button>
                        <div class="year-picker">
                            <p-datepicker [(ngModel)]="yearSettingsDatePicker" (onSelect)="navigateYearPicker($event)"
                                view="year" [readonlyInput]="true" dateFormat="yy" />
                        </div>
                        <button (click)="navigateYear('next')"
                            class="p-2 hover:bg-gray-100 rounded-lg border border-gray-200 shadow-sm transition-all text-gray-600">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round">
                                <path d="m9 18 6-6-6-6" />
                            </svg>
                        </button>
                    </div>
                    <div class="p-4 space-y-2 bg-white rounded-b-xl">
                        @for (day of yearHolidays; track day; let idx = $index) {
                        @let dayIndex = day.day === '1' ? 0 : idx + 1;
                        <div
                            class="flex items-center justify-between p-3 hover:bg-gray-50 rounded-lg transition-all group">
                            <span class="  text-gray-700 tracking-wide flex items-center gap-3">
                                <span class="w-1.5 h-1.5 rounded-full"
                                    [class]="day.day === '1' ? 'bg-red-500' : day.day === '7' ? 'bg-blue-500' : 'bg-gray-400'"></span>
                                <span *ngIf="day.day=== '2'">{{'TIMESSTR0024'|translate}}</span>
                                <span *ngIf="day.day=== '3'">{{'TIMESSTR0025'|translate}}</span>
                                <span *ngIf="day.day=== '4'">{{'TIMESSTR0026'|translate}}</span>
                                <span *ngIf="day.day=== '5'">{{'TIMESSTR0027'|translate}}</span>
                                <span *ngIf="day.day=== '6'">{{'TIMESSTR0028'|translate}}</span>
                                <span *ngIf="day.day=== '7'">{{'TIMESSTR0029'|translate}}</span>
                                <span *ngIf="day.day=== '1'">{{'TIMESSTR0023'|translate}}</span>
                            </span>
                            <button type="button" (click)="toggleWeeklyDay(dayIndex, day.day)" [disabled]="isPastYear()"
                                [class.opacity-50]="isPastYear()" [class.cursor-not-allowed]="isPastYear()"
                                class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none"
                                [class]="day.isUse ? 'bg-indigo-600' : 'bg-gray-200'">
                                <span
                                    class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"
                                    [class]="day.isUse ? 'translate-x-5' : 'translate-x-0'"></span>
                            </button>
                        </div>
                        }
                    </div>
                </div>
            </div>

            }
        </div>
    </div>
    }
</div>
</div>


<!-- address -->
<p-dialog header="" [modal]="true" [(visible)]="visible" [style]="{ width: '50rem' }"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [maximizable]="false">
    <div *ngIf="visible">
        <div id="postcode-wrapper"></div>
    </div>
</p-dialog>


<app-pop-up-common [showConfirm]="showConfirmDelete()" (confirmEvent)="deleteLevelOrMember()"
    (cancelEvent)="showConfirmDelete.set(false)" [message]="'SYSMESER0009'"></app-pop-up-common>

<app-pop-up-common [showConfirm]="showConfirmDeleteStaff()" (confirmEvent)="deleteStaff()"
    (cancelEvent)="showConfirmDeleteStaff.set(false)" [message]="'SYSMESER0009'"></app-pop-up-common>

<app-pop-up-common [showConfirm]="showActiveKey()" [showCancel]="false" (confirmEvent)="showActiveKey.set(false)"
    [copyText]="true" [title]="'AGENTSTR0004'" (cancelEvent)="showActiveKey.set(false)"
    [message]="activeKey"></app-pop-up-common>


@if(loading()){
<div class="loading-overlay">
    <div class="flex flex-col justify-center gap-4">
        <div class="flex items-center justify-center text-white w-full">
            <p>{{ loadingText() }}</p>
        </div>
        <div class="flex justify-center w-full">
            <div class="loader"></div>
        </div>
    </div>
</div>
}